// Helpers de data/hora no fuso de Brasília (America/Sao_Paulo), independentes do fuso do
// navegador. O backend envia/grava em horário de Brasília; aqui apenas exibimos/editamos no
// mesmo wall-clock. Extraídos de SalesOrderDetailView para serem testáveis.

// formatDateTimeBR exibe um timestamp como "dd/mm/yyyy hh:mm" sempre no fuso de Brasília.
// Monta a string a partir das partes do Intl para garantir o formato exato (sem vírgula).
export const formatDateTimeBR = (dateStr?: string | null): string => {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return '—';
  const p = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
    .formatToParts(d)
    .reduce<Record<string, string>>((acc, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});
  const hour = p.hour === '24' ? '00' : p.hour;
  return `${p.day}/${p.month}/${p.year} ${hour}:${p.minute}`;
};

// toBrazilDateTimeLocal converte um timestamp (ou "agora", quando ausente) para
// "YYYY-MM-DDTHH:MM" no wall-clock de Brasília, para uso em <input type="datetime-local">.
export const toBrazilDateTimeLocal = (dateStr?: string | null): string => {
  const d = dateStr ? new Date(dateStr) : new Date();
  if (Number.isNaN(d.getTime())) return '';
  const p = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
    .formatToParts(d)
    .reduce<Record<string, string>>((acc, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});
  const hour = p.hour === '24' ? '00' : p.hour;
  return `${p.year}-${p.month}-${p.day}T${hour}:${p.minute}`;
};
